// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__33V-c","title":"Header_title__2xxqT","side":"Header_side__Z0554"};